//Handle gift card amount buttons
document.querySelectorAll('.gift-card-amounts button').forEach((button) => {
  button.addEventListener('click', () => {
    const lineItemCustomAmount = document.querySelector('input#custom-selected-amount');
    if (lineItemCustomAmount) {
      lineItemCustomAmount.value = button.dataset.amount;
    }
  });
});

document.querySelector('.product-form__submit')?.addEventListener('click', () => {
  const syncMap = {
    'textarea#greeting': 'textarea#cardigan-form-greeting',
    'input#custom-amount': 'input#custom-selected-amount',
    'input#recipient-name': 'input#cardigan-form-recipient-name',
    'input#recipient-email': 'input#cardigan-product-form-recipient-email',
    'input#sender-name': 'input#cardigan-form-sender-name',
    'input#delivery-date': 'input#cardigan-form-delivery-date',
  };

  // Loop through each mapping and sync value
  Object.entries(syncMap).forEach(([sourceSelector, targetSelector]) => {
    const source = document.querySelector(sourceSelector);
    const target = document.querySelector(targetSelector);
    if (source && target) {
      target.value = source.value;
    }
  });

  // Handle special case for today's date picker
  const deliveryDateInput = document.querySelector('#delivery-date');
  let deliveryDateValue = deliveryDateInput.value;
  let timeInAEST = ' ';
  let giftCardDeliveryDate = window.giftCardDeliveryDate;
  const lineItemDeliveryDateInput = document.querySelector('#cardigan-form-delivery-date');
  const today = new Date().toLocaleDateString('en-AU', {
    timeZone: 'Australia/Sydney'
  });

  // Use the date format Y-m-d to ensure compatibility with the Cardigan scheduled date.

  const [day, month, year] = deliveryDateValue.split("/");
  const date = new Date(`${year}-${month}-${day}`);
  const FormatedDeliveryDateValue = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;

  if (deliveryDateValue === today) {
    timeInAEST = new Date().toLocaleTimeString("en-AU", {
      timeZone: "Australia/Sydney", 
      hour12: false,
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
    deliveryDateValue = FormatedDeliveryDateValue + 'T' + timeInAEST;
  } else {
    deliveryDateValue = FormatedDeliveryDateValue + 'T' + giftCardDeliveryDate;
  }

  if (deliveryDateInput?.value && lineItemDeliveryDateInput) {
    lineItemDeliveryDateInput.value = deliveryDateValue;
  }
});

document.querySelectorAll('.product-form__input--button-circle input[type="radio"]')
  .forEach(radio => {
    radio.addEventListener('change', () => {
      if (radio.value === 'by email') {
        const lineItemDeliveryDateInput = document.querySelector('#cardigan-form-delivery-date');
        if (lineItemDeliveryDateInput) {
          lineItemDeliveryDateInput.value = '';
        }
      }
    });
  });

document.querySelector('#select_date_picker')?.addEventListener('change', () => {
  const lineItemDeliveryDateInput = document.querySelector('#cardigan-form-delivery-date');
  if (lineItemDeliveryDateInput) {
    lineItemDeliveryDateInput.value = '';
  }
});